export const colors = [
    '#ff9f45',
    '#009379',
    '#3366ff',
    '#ff6250',
    '#ffdf90',
    '#bfaff2',
    '#008c99',
    '#00c4cc',
    '#ff7eb9',
    '#a05a2c',
    '#b4d400',
    '#4b0082',
];
